var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"left":"","disabled":!_vm.tooltip},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({class:_vm.hasVerticalScrollbar && !_vm.fixed
        ? [
          'fb', ("fb-bottom-" + _vm.bottomOffset),
          ("fb-" + (_vm.isDrawerVisible ? '' : 'no-') + "drawer-" + _vm.leftOffset)
        ] : [],attrs:{"type":_vm.type,"fixed":_vm.hasVerticalScrollbar,"loading":_vm.loading,"color":_vm.color},on:{"click":function($event){_vm.$emit ('click')}}},on),[_vm._t("default")],2)]}}],null,true)},[_c('span',{domProps:{"textContent":_vm._s(_vm.tooltip)}})])}
var staticRenderFns = []

export { render, staticRenderFns }